<div class="controls-container">
    <div class="controls-header">Radio Button</div>

    <div class="controls-sub-header">Radio Button Default</div>
    <pm-radio-button *ngFor="let item of DefaultItems"
        [style.padding.px]="4"
        [(RadioGroup)]="DefaultGroup"
        [Value]="item.Value"
        [Label]="item.Label"
        [(IsChecked)]="item.IsChecked"
        [IsDisabled]="item.IsDisabled">
    </pm-radio-button>

    <div class="controls-sub-header">CheckBox Theme 1</div>
    <pm-radio-button *ngFor="let item of Theme1Items"
        [style.padding.px]="4"
        [(RadioGroup)]="Theme1Group"
        [Value]="item.Value"
        [Label]="item.Label"
        [(IsChecked)]="item.IsChecked"
        [IsDisabled]="item.IsDisabled"
        RadioButtonOuterTheme="radio-button-theme-1-outer-selected"
        RadioButtonInnerTheme="radio-button-theme-1-inner-selected">
    </pm-radio-button>

    <div class="controls-sub-header">CheckBox Theme 2</div>
    <pm-radio-button *ngFor="let item of Theme2Items"
        [style.padding.px]="4"
        [(RadioGroup)]="Theme2Group"
        [Value]="item.Value"
        [Label]="item.Label"
        [(IsChecked)]="item.IsChecked"
        [IsDisabled]="item.IsDisabled"
        RadioButtonOuterTheme="radio-button-theme-2-outer-selected"
        RadioButtonInnerTheme="radio-button-theme-2-inner-selected">
    </pm-radio-button>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/radio-button/radio-button.html